import {APP_INITIALIZER, ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClientModule} from '@angular/common/http';
import {Router} from '@angular/router';
import * as Sentry from '@sentry/angular';

import {SharedModule} from './shared/shared.module';
import {CoreModule} from './core/core.module';
import {TranslocoRootModule} from './transloco-root/transloco-root.module';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {HomeModule} from './pages/home/home.module';
import {UserModule} from './pages/user/user.module';
import {AuthenticationModule} from './pages/authentication/authentication.module';
import {SensorModule} from './pages/sensor/sensor.module';
import {BoxModule} from './pages/box/box.module';
import {PatientModule} from './pages/patient/patient.module';
import {SettingsModule} from './pages/settings/settings.module';
import {HealthCenterModule} from './pages/health-center/health-center.module';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,

    SharedModule,
    CoreModule,
    TranslocoRootModule,

    AppRoutingModule,
    AuthenticationModule,
    HomeModule,
    UserModule,
    SensorModule,
    BoxModule,
    PatientModule,
    SettingsModule,
    HealthCenterModule
  ],
  providers: [{
    provide: ErrorHandler,
    useValue: Sentry.createErrorHandler({}),
  }, {
    provide: Sentry.TraceService,
    deps: [Router],
  }, {
    provide: APP_INITIALIZER,
    useFactory: (): (() => void) => {
      return () => {
      };
    },
    deps: [Sentry.TraceService],
    multi: true,
  }],
  bootstrap: [AppComponent],
})
export class AppModule {
}
